import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const bp_chart_options = ({
    data
}) => {
    return {
        title: {
            text: "",
            align: "left"
        },
        rangeSelector: {
            selected: 1
        },
        chart: {
            type: 'scatter',
            panKey: "alt",
            panning: true,
            borderRadius: 8,
        },
        xAxis: {
            type: "datetime",
            ordinal: false,
            gridLineColor: '#D2D8E5',
            lineColor: '#D2D8E5',
            scrollbar: {
                enabled: false
            },
            labels: {
                style: {
                    fontFamily: 'Nunito',
                    color: '#8F8F8F',
                    fontSize: '10px'
                }
            }
        },
        yAxis: {
            gridLineColor: '#D2D8E5',
            lineColor: '#D2D8E5',
            startOnTick: false,
            endOnTick: false,
            minorGridLineWidth: 1.5,
            minorTickInterval: "auto",
            minorTickLength: 0.5,
            minorTickWidth: 0.5,
            minorTickPosition: "outside",

            labels: {
                y: 4,
                style: {
                    fontFamily: 'Nunito',
                    color: '#8F8F8F',
                    fontSize: '10px'
                }
            },

        },
        series: [{
            name: "Blood Sugar",
            showInLegend: false,
            color: '#0000FF',
            data,
            gapSize: 2
        }],
        labels: {
            overflow: "scroll"
        },
        navigator: {
            enabled: false
        },
        scrollbar: {
            enabled: false
        },
        plotOptions: {
            scatter: {
                marker: {
                    radius: 6,
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                },
            }
        },
        exporting: {
            enabled: true
        },
        tooltip: {
            formatter: function () {
                return `<b>Blood Sugar:</b> ${this.y} mm/dL at ${dayjs.utc(this.x).format("hh:mm A, DD MMM")}`;
            },
        },
    }
};

export default bp_chart_options;